import React from "react"

import { TextField } from "../fields/TextField"
import { useFormContext, useWatch } from "react-hook-form"
import { InputProps } from "@rebass/forms"

type Props = InputProps & {
  name: string
  label?: string
  inputId?: string
  css?: any
  helperText?: string
}

export const TextInput = ({
  label,
  name,
  onChange,
  css,
  ...restProps
}: Props) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext()

  const { ref, onChange: hookOnChange, ...hookFormProps } = register(name)

  const customOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }
    hookOnChange(e)
  }

  const value =
    useWatch({
      name,
      control,
    }) || ""

  return (
    <TextField
      label={label}
      error={errors && errors[name]?.message}
      value={value}
      innerRef={ref}
      css={css}
      onChange={customOnChange}
      {...restProps}
      {...hookFormProps}
    />
  )
}
